import type { Choice } from "@memorang/types";
import { RadioButton, Text, TouchableRipple } from "react-native-paper";
import Box from "../../Box";
import ListBottomSheetWrapper from "../../ListBottomSheetWrapper";

type Props = {
	visible: boolean;
	onDismiss: () => void;
	choices: Choice[];
	selectedId?: string;
	onSelectChoice: (choiceId: string) => void;
};

const InlineBlankChoiceSheet = ({
	visible,
	onDismiss,
	choices,
	selectedId,
	onSelectChoice,
}: Props) => (
	<ListBottomSheetWrapper
		showModal={visible}
		title="Select an answer"
		handleSheetClose={onDismiss}
		snapPoints={["50%", "80%"]}
	>
		{choices.map((choice) => {
			const isSelected = choice.id === selectedId;
			const handlePress = () => {
				onSelectChoice(choice.id);
				onDismiss();
			};
			return (
				<TouchableRipple key={choice.id} onPress={handlePress}>
					<Box
						flexDirection="row"
						alignItems="center"
						gap={16}
						paddingHorizontal={8}
						paddingVertical={12}
					>
						<RadioButton.Android
							value={choice.id}
							status={isSelected ? "checked" : "unchecked"}
							onPress={handlePress}
						/>
						<Text variant="bodyLarge" style={{ flex: 1 }}>
							{choice.text ?? choice.id}
						</Text>
					</Box>
				</TouchableRipple>
			);
		})}
	</ListBottomSheetWrapper>
);

export default InlineBlankChoiceSheet;
